import { Field, Form, Formik } from 'formik'
import Header from 'components/headers/addLoan'
import AddNewIcon from 'assets/images/loans/managementAddNew.svg'
import CustomDatePicker from 'components/datePicker'
import Num2persian from 'utilities/helper/num2Persian'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FeeModal from 'components/modals/feeModal'
import { Schema } from './utils'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import { toast } from 'react-toastify'
import { toggleAddNewLoan } from 'store/redux/moneyPoolBox'
import { NumericFormat } from 'react-number-format'

export default function AddNewLoan() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const [selectedFee, setSelectedFee] = useState<number | undefined>()
    const [isOpenFeeModal, setIsOpenFeeModal] = useState<boolean>(false)
    const [selectedFeeType, setSelectedFeeType] = useState<string>('percentage')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <>
            <Formik
                initialValues={{
                    date: '',
                    amount: '',
                    number: '',
                    tag: '',
                    repayment_amount: '',
                    fee_type: '',
                }}
                validationSchema={Schema}
                onSubmit={(values) => {
                    if (Number(values.amount) >= 5000) {
                        if (values.fee_type !== '') {
                            if (selectedFee !== undefined) {
                                if (
                                    Number(values.repayment_amount) <
                                    Number(values.number)
                                ) {
                                    const payload: IAddBoxNewLoanPayload = {
                                        id: store.loans.length,
                                        ...(values.date !== '' && {
                                            date: values.date,
                                        }),
                                        amount: values.amount,
                                        number: values?.number,
                                        tag: values.tag,
                                        repayment_amount:
                                            values.repayment_amount,
                                        fee: String(selectedFee),
                                        feeType: values.fee_type,
                                        selectedFeeType: selectedFeeType,
                                    }
                                    dispatch(toggleAddNewLoan(payload))
                                    toast.success('وام شما باموفقیت ثبت شد')
                                    navigate(-1)
                                } else {
                                    toast.error(
                                        'تعداد اقساط پرداخت شده نمی تواند از تعداد کل افساز بیشتر باشد'
                                    )
                                }
                            } else {
                                toast.error('کارمزد را وارد کنید')
                            }
                        } else {
                            toast.error('نحوه دریافت کارمزد را وارد کنید')
                        }
                    } else {
                        toast.error(
                            'مبلغ وام نمی تواند کمتر از 5000 تومان باشد'
                        )
                    }
                }}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen text-sm ">
                            <div className=" grow-0">
                                <Header title="اعطای وام" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className="  bg-white  mt-14 rounded-lg relative py-4 shadow-[0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_1px_0px_0px_rgba(25,28,33,0.02),0px_0px_0px_1px_rgba(25,28,33,0.08)]">
                                    <div className=" text-center mt-4">
                                        <img
                                            src={AddNewIcon}
                                            alt="add-loan"
                                            className=" absolute right-[35%] md:right-[40%] lg:right-[40%] -top-14"
                                        />
                                    </div>
                                    <div
                                        dir="rtl"
                                        className="border-b border-dashed border-gray-1"
                                    >
                                        <>
                                            <CustomDatePicker
                                                setValue={(e: string) => {
                                                    setFieldValue('date', e)
                                                }}
                                                name={'date'}
                                                title="تاریخ اعطای وام"
                                                placeHolder="تاریخ اعطای وام"
                                            />
                                        </>
                                    </div>
                                    <div className="  w-full text-center">
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            placeholder="مبلغ وام (تومان)"
                                            allowNegative={false}
                                            name="amount"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />

                                        {values.amount !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    values.amount.toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}

                                        <div className=" w-full text-center">
                                            <Field
                                                type="number"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3  "
                                                name="number"
                                                placeholder="تعداد اقساط "
                                                min={0}
                                            />
                                            {errors.number &&
                                                touched.number && (
                                                    <p className=" text-sm text-error-3 text-center">
                                                        {errors.number}
                                                    </p>
                                                )}
                                        </div>
                                        <div
                                            onClick={() =>
                                                setIsOpenFeeModal(true)
                                            }
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-placeholder bg-white"
                                        >
                                            {selectedFee !== undefined
                                                ? `${selectedFee} ${
                                                      selectedFeeType ===
                                                      'percentage'
                                                          ? 'درصد'
                                                          : 'تومان'
                                                  }`
                                                : 'میزان کارمزد'}
                                        </div>
                                        <Field
                                            name="fee_type"
                                            as="select"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                        >
                                            <option className="text-gray-1">
                                                نحوه دریافت کارمزد
                                            </option>
                                            <option value="lip_ma">
                                                افزودن به هر قسط
                                            </option>
                                            <option value="lip_pr">
                                                کسر از مبلغ وام
                                            </option>
                                        </Field>
                                        <div className=" w-full text-center">
                                            <Field
                                                type="number"
                                                className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3 text-[#000000]  "
                                                name="repayment_amount"
                                                placeholder="تعداد اقساط پرداخت شده"
                                                min={0}
                                            />
                                            {errors.repayment_amount &&
                                                touched.repayment_amount && (
                                                    <p className=" text-sm text-error-3 text-center">
                                                        {
                                                            errors.repayment_amount
                                                        }
                                                    </p>
                                                )}
                                        </div>
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات(اختیاری)"
                                        />
                                        {errors.tag && touched.tag && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.tag}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                            >
                                ثبت وام
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 "
                                onClick={() => navigate(-1)}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <FeeModal
                show={isOpenFeeModal}
                onHide={() => setIsOpenFeeModal(false)}
                setSelectedFee={setSelectedFee}
                setSelectedFeeType={setSelectedFeeType}
            />
        </>
    )
}
